import React from "react";

const AndroidAppStoreIcon = ({ width, height, fill, fill2 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 217 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2529_9883)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M208.735 64H8.74122C4.33047 64 0.738281 60.393 0.738281 56V8C0.738281 3.59102 4.33047 0 8.74122 0H208.735C213.142 0 216.738 3.59102 216.738 8V56C216.738 60.393 213.142 64 208.735 64Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M208.735 1.2808C212.435 1.2808 215.463 4.30125 215.463 8V56C215.463 59.6988 212.455 62.7192 208.735 62.7192H8.74122C5.04175 62.7192 2.01382 59.6988 2.01382 56V8C2.01382 4.30125 5.02188 1.2808 8.74122 1.2808H208.735ZM208.735 0H8.74122C4.33047 0 0.738281 3.60698 0.738281 8V56C0.738281 60.409 4.33047 64 8.74122 64H208.735C213.142 64 216.738 60.409 216.738 56V8C216.738 3.60698 213.142 0 208.735 0Z"
          fill={fill2}
        />
        <path
          d="M114.526 21.1713C113.083 21.1713 111.867 20.6646 110.906 19.6671C109.952 18.6975 109.42 17.3609 109.444 15.9963C109.444 14.5399 109.936 13.307 110.906 12.3294C111.863 11.3319 113.079 10.8252 114.522 10.8252C115.948 10.8252 117.164 11.3319 118.142 12.3294C119.111 13.3389 119.604 14.5718 119.604 15.9963C119.588 17.4566 119.095 18.6895 118.142 19.6631C117.184 20.6686 115.968 21.1713 114.526 21.1713ZM71.6066 21.1713C70.1959 21.1713 68.9721 20.6726 67.9707 19.687C66.9773 18.7055 66.4727 17.4646 66.4727 16.0003C66.4727 14.5359 66.9773 13.295 67.9707 12.3135C68.9522 11.3279 70.1761 10.8292 71.6066 10.8292C72.3059 10.8292 72.9854 10.9688 73.6371 11.2521C74.2769 11.5274 74.7974 11.9025 75.1829 12.3614L75.2782 12.4771L74.2014 13.5384L74.0901 13.4067C73.4821 12.6806 72.6675 12.3254 71.5907 12.3254C70.6291 12.3254 69.7906 12.6686 69.0992 13.3469C68.4038 14.0292 68.0502 14.923 68.0502 16.0042C68.0502 17.0855 68.4038 17.9793 69.0992 18.6616C69.7906 19.3399 70.6291 19.6831 71.5907 19.6831C72.6159 19.6831 73.4782 19.3399 74.1497 18.6616C74.5471 18.2626 74.7934 17.704 74.8809 16.9978H71.4278V15.5055H76.363L76.3829 15.6412C76.4187 15.8925 76.4544 16.1519 76.4544 16.3913C76.4544 17.7678 76.0412 18.8811 75.2226 19.703C74.2928 20.6766 73.0768 21.1713 71.6066 21.1713ZM128.672 20.9599H127.15L122.489 13.4706L122.529 14.8192V20.9559H121.007V11.0407H122.743L122.791 11.1165L127.174 18.1708L127.134 16.8262V11.0407H128.672V20.9599ZM103.09 20.9599H101.548V12.5329H98.8736V11.0407H105.76V12.5329H103.086V20.9599H103.09ZM97.618 20.9599H96.0802V11.0407H97.618V20.9599ZM88.9753 20.9599H87.4375V12.5329H84.7633V11.0407H91.6496V12.5329H88.9753V20.9599ZM83.7897 20.9439H77.8929V11.0407H83.7897V12.5329H79.4346V15.2541H83.3646V16.7304H79.4346V19.4516H83.7897V20.9439ZM112.034 18.6417C112.722 19.3319 113.556 19.6791 114.526 19.6791C115.523 19.6791 116.338 19.3399 117.017 18.6417C117.693 17.9634 118.035 17.0736 118.035 16.0003C118.035 14.9269 117.693 14.0332 117.021 13.3589C116.334 12.6686 115.495 12.3215 114.53 12.3215C113.532 12.3215 112.718 12.6606 112.042 13.3589C111.367 14.0372 111.025 14.9269 111.025 16.0003C111.025 17.0736 111.363 17.9673 112.034 18.6417Z"
          fill={fill2}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.302 34.8091C105.547 34.8091 102.503 37.6699 102.503 41.616C102.503 45.5263 105.567 48.423 109.302 48.423C113.057 48.423 116.101 45.5422 116.101 41.616C116.101 37.6699 113.057 34.8091 109.302 34.8091ZM109.302 45.7258C107.248 45.7258 105.479 44.018 105.479 41.6001C105.479 39.1462 107.252 37.4744 109.302 37.4744C111.356 37.4744 113.125 39.1462 113.125 41.6001C113.129 44.034 111.356 45.7258 109.302 45.7258ZM94.4683 34.8091C90.7132 34.8091 87.6694 37.6699 87.6694 41.616C87.6694 45.5263 90.7331 48.423 94.4683 48.423C98.2234 48.423 101.267 45.5422 101.267 41.616C101.267 37.6699 98.2195 34.8091 94.4683 34.8091ZM94.4683 45.7258C92.4139 45.7258 90.6457 44.018 90.6457 41.6001C90.6457 39.1462 92.4179 37.4744 94.4683 37.4744C96.5227 37.4744 98.291 39.1462 98.291 41.6001C98.291 44.034 96.5227 45.7258 94.4683 45.7258ZM76.8173 36.8879V39.7687H83.7037C83.4931 41.3846 82.9606 42.5776 82.146 43.3956C81.1367 44.4091 79.579 45.5103 76.8332 45.5103C72.6013 45.5103 69.2912 42.0789 69.2912 37.8295C69.2912 33.5801 72.6013 30.1487 76.8332 30.1487C79.1181 30.1487 80.783 31.0544 82.0188 32.2116L84.0534 30.1687C82.3367 28.5168 80.0519 27.252 76.8491 27.252C71.0436 27.252 66.1719 32.0001 66.1719 37.8135C66.1719 43.643 71.0396 48.3751 76.8491 48.3751C79.9843 48.3751 82.3367 47.3457 84.1964 45.4066C86.0918 43.5033 86.6919 40.818 86.6919 38.6515C86.6919 37.9771 86.6402 37.3707 86.5329 36.8559H76.8133C76.8173 36.852 76.8173 36.8879 76.8173 36.8879ZM149.015 39.1303C148.447 37.6021 146.73 34.7931 143.209 34.7931C139.72 34.7931 136.82 37.5502 136.82 41.6001C136.82 45.4225 139.689 48.4071 143.547 48.4071C146.646 48.4071 148.451 46.5038 149.194 45.3866L146.893 43.8385C146.13 44.9756 145.069 45.7218 143.563 45.7218C142.041 45.7218 140.976 45.0275 140.269 43.6589L149.333 39.8884C149.333 39.8924 149.015 39.1303 149.015 39.1303ZM139.772 41.4046C139.701 38.7751 141.807 37.4385 143.313 37.4385C144.501 37.4385 145.49 38.025 145.828 38.8789L139.772 41.4046ZM132.409 48.0001H135.385V28.0021H132.409V48.0001ZM127.521 36.3213H127.414C126.742 35.5193 125.467 34.7931 123.838 34.7931C120.456 34.7931 117.341 37.7816 117.341 41.62C117.341 45.4425 120.44 48.3951 123.838 48.3951C125.447 48.3951 126.742 47.6649 127.414 46.847H127.521V47.8245C127.521 50.422 126.138 51.8225 123.909 51.8225C122.085 51.8225 120.953 50.5058 120.492 49.4046L117.905 50.4899C118.648 52.2854 120.631 54.5078 123.905 54.5078C127.394 54.5078 130.35 52.445 130.35 47.4135V35.2001H127.537V36.3213C127.541 36.3213 127.521 36.3213 127.521 36.3213ZM124.104 45.7258C122.05 45.7258 120.333 44.0021 120.333 41.62C120.333 39.218 122.05 37.4784 124.104 37.4784C126.138 37.4784 127.716 39.238 127.716 41.62C127.736 44.0021 126.142 45.7258 124.104 45.7258ZM162.95 28.0021H155.834V48.0001H158.81V40.427H162.954C166.249 40.427 169.487 38.029 169.487 34.2225C169.487 30.416 166.26 28.0021 162.95 28.0021ZM163.038 37.634H158.806V30.7712H163.038C165.267 30.7712 166.527 32.6185 166.527 34.2026C166.527 35.7707 165.251 37.634 163.038 37.634ZM181.416 34.7731C179.254 34.7731 177.025 35.7347 176.103 37.8295L178.742 38.9308C179.31 37.8295 180.351 37.4544 181.452 37.4544C182.994 37.4544 184.551 38.3801 184.587 40.032V40.2435C184.055 39.9402 182.886 39.4774 181.488 39.4774C178.638 39.4774 175.75 41.0415 175.75 43.9741C175.75 46.6594 178.086 48.3831 180.689 48.3831C182.688 48.3831 183.788 47.4774 184.476 46.428H184.583V47.9761H187.452V40.3153C187.452 36.7482 184.813 34.7731 181.416 34.7731ZM181.042 45.7258C180.069 45.7258 178.706 45.247 178.706 44.018C178.706 42.4699 180.407 41.8834 181.857 41.8834C183.168 41.8834 183.788 42.1667 184.567 42.5577C184.353 44.3532 182.843 45.7098 181.042 45.7258ZM197.919 35.2001L194.501 43.8744H194.394L190.853 35.2001H187.651L192.963 47.3258L189.936 54.0649H193.035L201.209 35.2001H197.919ZM171.128 48.0001H174.104V28.0021H171.128V48.0001Z"
          fill={fill2}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3639 12.054C16.903 12.5528 16.6367 13.3149 16.6367 14.3124V49.6919C16.6367 50.6894 16.903 51.4515 17.3798 51.9303L17.503 52.0381L37.2441 32.2156V31.7727L17.4871 11.9463L17.3639 12.054Z"
          fill="url(#paint0_linear_2529_9883)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.8109 38.843L37.2266 32.2315V31.7687L43.8109 25.1572L43.954 25.245L51.7424 29.6899C53.9716 30.9507 53.9716 33.0335 51.7424 34.3103L43.954 38.7552L43.8109 38.843Z"
          fill="url(#paint1_linear_2529_9883)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.955 38.7551L37.2276 32L17.3633 51.9461C18.0905 52.7282 19.3104 52.816 20.6733 52.0539L43.955 38.7551Z"
          fill="url(#paint2_linear_2529_9883)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.955 25.2449L20.6733 11.9661C19.3104 11.1841 18.0865 11.2918 17.3633 12.0738L37.2276 32L43.955 25.2449Z"
          fill="url(#paint3_linear_2529_9883)"
        />
        <path
          opacity="0.2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.8118 38.6113L20.689 51.8023C19.3975 52.5484 18.2452 52.4966 17.5021 51.8183L17.3789 51.942L17.5021 52.0497C18.2452 52.724 19.3975 52.7799 20.689 52.0337L43.9708 38.755L43.8118 38.6113Z"
          fill={fill}
        />
        <path
          opacity="0.12"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.7442 34.0788L43.793 38.6115L43.936 38.7551L51.7244 34.3102C52.841 33.6718 53.3893 32.8339 53.3893 32C53.3218 32.7661 52.7536 33.4923 51.7442 34.0788Z"
          fill={fill}
        />
        <path
          opacity="0.25"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.674 12.1977L51.744 29.9214C52.7533 30.4919 53.3215 31.2381 53.4089 32.0002C53.4089 31.1662 52.8606 30.3283 51.744 29.6899L20.674 11.9662C18.4447 10.6854 16.6367 11.7548 16.6367 14.3124V14.5438C16.6367 11.9822 18.4447 10.9328 20.674 12.1977Z"
          fill={fill2}
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2529_9883"
          x1="35.4734"
          y1="13.9307"
          x2="3.83431"
          y2="22.3263"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.00657" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2529_9883"
          x1="54.6495"
          y1="32.0002"
          x2="16.0932"
          y2="32.0002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2529_9883"
          x1="40.2969"
          y1="35.6757"
          x2="14.7565"
          y2="78.4861"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2529_9883"
          x1="12.3612"
          y1="0.286088"
          x2="23.7559"
          y2="19.4059"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <clipPath id="clip0_2529_9883">
          <rect
            width="216"
            height="64"
            fill="white"
            transform="translate(0.738281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AndroidAppStoreIcon;
